import { Box, Card, CardContent, styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useAppSelector } from "../../../app/hooks";
import { selectLoggedInUser } from "../../auth/auth.slice";

const StyledCard = styled(Card)(({ theme }) => ({
  '& .MuiCardContent-root': {
    paddingBottom: '12px !important',
  }
}));

interface BillingInfoItemProps {
  label: string;
  value: string | number;
}

const BillingInfoItem: React.FC<BillingInfoItemProps> = ({ label, value }) => {
  return (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="subtitle1" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="subtitle1" color="textPrimary">
        {value}
      </Typography>
    </Box>
  );
};

const BillingInformation = () => {
  const loggedInUserDetails = useAppSelector(selectLoggedInUser);

  return (
    <>
      <Typography variant="h6">Billing Information</Typography>
      <Box sx={{ maxWidth: { xs: '100%', sm: 275 }, width: '100%' }}>
        <StyledCard variant="outlined" sx={{ marginTop: '12px' }} >
          <CardContent sx={{ paddingBottom: "12px" }}>
            <BillingInfoItem label="Current Plan:" value={loggedInUserDetails?.roleData.businessUser?.business.plan.name ?? ''} />
            <BillingInfoItem label="Per Member/Month:" value={`${loggedInUserDetails?.roleData.businessUser?.business.plan.price ?? 0} LKR`} />
            <BillingInfoItem label="Discount Percentage:" value={`${loggedInUserDetails?.roleData.businessUser?.business.discountPercentage ?? 0}%`} />
            <BillingInfoItem label="Next Billing Date:" value={loggedInUserDetails?.roleData.businessUser?.business.nextBillingDate ?? 'N/A'} />
            <BillingInfoItem label="Due Amount" value={`${loggedInUserDetails?.roleData.businessUser?.business.dueAmount ?? 0} LKR`} />
            {/* <BillingInfoItem label="Membership Status:" value={loggedInUserDetails?.business.status ?? ''} /> */}
          </CardContent>
        </StyledCard>
      </Box>
    </>
  );
}

export default BillingInformation;